import { enableFade } from 'core/handlers/FadeHandler'
import { signal } from 'services/SignalsService'

export default class MenuBackEntity extends PIXI.Container {
  constructor() {
    super()
    this.fade = enableFade(this)
    signal.on('RADIO:ui', this.activate.bind(this))
  }

  activate(value) {
    this.fade(!!value)
  }
}
